module.exports = __webpack_public_path__ + "static/media/104cc9a5-4e9a-40ce-9a68-e0b11b800415.8ab282e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/completion/104cc9a5-4e9a-40ce-9a68-e0b11b800415.png
// module id = 1490
// module chunks = 0